import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { VehiculeQueryFilter } from '../../shared/types';
import { CITRIN_GET_VEHICULES, GetVehiculesRequest, GetVehiculesResponse } from '..';

export const useGetVehiculesQuery = (request: VehiculeQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: VehiculeQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetVehiculesResponse, GetVehiculesRequest>(CITRIN_GET_VEHICULES, {
        variables: { request: internalRequest },
        //fetchPolicy: 'cache-and-network',
        //onCompleted: (data) => console.log('[MGT] Users', data),
    });

    return { ...rest, previousData: previousData?.CITRIN_MGT_getVehicules, data: data?.CITRIN_MGT_getVehicules ?? [] };
};
